import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

// Çeyreklik prim hedefleri. team_id XOR user_id (ikisi birden olamaz).
// İkisi de boş ise şirket geneli hedef.
const useBonusTargets = () => {
  const { user } = useAuth();

  const dynamicHook = useDynamicEntity({
    entityType: 'bonusTargets',
    gqlEntityKey: 'bonus_targets',
    queryName: 'GET_BONUS_TARGETS_QUERY',
    createMutation: 'CREATE_BONUS_TARGET_MUTATION',
    updateMutation: 'UPDATE_BONUS_TARGET_MUTATION',
    deleteMutation: 'DELETE_BONUS_TARGET_MUTATION',
    transformData: (row) => {
      let target_kapsami = 'Şirket Geneli';
      if (row.team_id && row.team) {
        target_kapsami = row.team.name;
      } else if (row.user_id && row.user) {
        target_kapsami = `${row.user.first_name || ''} ${row.user.last_name || ''}`.trim()
          || `Kullanıcı #${row.user_id}`;
      }
      return {
        ...row,
        company_name: row.company?.name || `Company ${row.company_id}`,
        target_kapsami,
        period_label: `${row.yil}/Q${row.ceyrek}`,
        companyId: row.company_id,
      };
    },
    transformFormData: (formData) => {
      const teamId = formData.team_id ? parseInt(formData.team_id) : null;
      const userId = formData.user_id ? parseInt(formData.user_id) : null;
      // Defansif: form-level XOR (showIf) zaten engelliyor ama API doğrudan
      // çağrılırsa DB CHECK yerine net mesaj göster. Kök sebep zaten
      // i18n'de ayrıca kayıtlı, throw mesajı kullanıcıya görünür.
      if (teamId && userId) {
        throw new Error('Bir hedef hem ekibe hem kullanıcıya atanamaz — birini seçin veya ikisini de boş bırakın');
      }
      return {
        yil: parseInt(formData.yil) || new Date().getFullYear(),
        ceyrek: parseInt(formData.ceyrek) || 1,
        team_id: teamId,
        user_id: userId,
        hedef_tutar: parseFloat(formData.hedef_tutar) || 0,
        aciklama: formData.aciklama || null,
      };
    },
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });

  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useBonusTargets };
